export interface HeroSlide {
  id: string;
  title: string;
  tagline: string;
  image: string;
  rating: number;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 'changye-zhuiguang',
    title: '长夜追光',
    tagline: '十五年悬案重启 · 悬疑犯罪力作',
    image: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20moody%20rainy%20city%20street%20at%20night%2C%20deep%20blue%20and%20amber%20neon%20tones%2C%20lone%20figure%20walking%2C%20atmospheric%20film%20banner%20with%20dark%20negative%20space%2C%20no%20text&width=1600&height=700&seq=qx-hero-01&orientation=landscape',
    rating: 8.7,
  },
  {
    id: 'shanhai-miwu',
    title: '山海秘闻录',
    tagline: '山海异兽现世 · 东方奇幻大剧',
    image: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20misty%20ancient%20Chinese%20mountains%20and%20temple%2C%20ink%20painting%20style%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20oriental%20fantasy%20atmosphere%20with%20dark%20negative%20space%2C%20no%20text&width=1600&height=700&seq=qx-hero-02&orientation=landscape',
    rating: 8.9,
  },
  {
    id: 'xinghai-jiyuan',
    title: '星海纪元',
    tagline: '远征未知星系 · 科幻史诗巨制',
    image: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20deep%20space%20with%20distant%20spaceship%20and%20orange%20nebula%2C%20deep%20blue%20and%20amber%20tones%2C%20epic%20sci-fi%20atmosphere%20with%20dark%20negative%20space%2C%20no%20text&width=1600&height=700&seq=qx-hero-03&orientation=landscape',
    rating: 8.2,
  },
  {
    id: 'quanli-migong',
    title: '权力迷宫',
    tagline: '权力暗流涌动 · 高分悬疑剧集',
    image: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20shadowy%20government%20corridor%20with%20light%20beam%20through%20columns%2C%20deep%20navy%20and%20gold%20tones%2C%20tense%20political%20thriller%20atmosphere%2C%20dark%20negative%20space%2C%20no%20text&width=1600&height=700&seq=qx-hero-04&orientation=landscape',
    rating: 9.0,
  },
];

export default heroSlides;